import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { useConfig } from '@/contexts/configProvider'
import { projectService } from '@/services/http/projectService'

export const useGetMyCountProjects = () => {
  const { toast } = useToast()
  const { config } = useConfig()

  // `=== true` de propósito: no TanStack Query v5 `enabled: undefined` vale
  // como `true` (shouldFetchOnMount usa `enabled !== false`). Enquanto a config
  // do tenant carrega, `config?.hasProjectModule` é `undefined` — sem o
  // `=== true` a query dispararia mesmo assim, e a rota de projetos responderia
  // 403 para tenant sem o módulo.
  const hasProjectModule = config?.hasProjectModule === true

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['myCountProjects'],
    queryFn: () => projectService.project.getMyCountProjects(),
    enabled: hasProjectModule,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar os projetos',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      myCountProjects: data,
      isLoading,
      refetchMyCountProjects: refetch,
    }
  }

  return {
    myCountProjects: {
      all: 0,
      myProjectsResponsible: 0,
      myProjectsMember: 0,
    },
    isError,
    isLoading,
    refetchMyCountProjects: refetch,
  }
}
